module.exports = __webpack_public_path__ + "static/img/mediaCom.78ad79f3.png";